var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftmenu"},_vm._l((_vm.menuList),function(item,index){return _c('div',{staticClass:"menu-class"},[_c('a',{staticClass:"a-menu-class",on:{"click":function($event){return _vm.toRouterByUrl(item.url)}}},[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620d1c00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/LeftMenu.vue
// module id = null
// module chunks = 